import { gql, TypedDocumentNode } from '@common/hooks';
import {
  MissionControlPaginatedApprovalChainsQueryVariables,
  MissionControlPaginatedApprovalChainsQueryCgResponse,
} from '@common/graphql';

export type MissionControlStaffingRequestApprovableType = Extract<
  NonNullable<
    MissionControlPaginatedApprovalChainsQueryCgResponse['missionControlPaginatedApprovalChains']['approvalChains']
  >[number]['approvable'],
  { __typename: 'StaffingRequest' }
>;

export type MissionControlStaffingRequestApprovalChainType = {
  id: string;
  createdAt: string;
  approvable: MissionControlStaffingRequestApprovableType;
  __typename: 'ApprovalChain';
};

export const MISSION_CONTROL_APPROVAL_CHAINS_PENDING_QUERY: TypedDocumentNode<
  MissionControlPaginatedApprovalChainsQueryCgResponse,
  MissionControlPaginatedApprovalChainsQueryVariables
> = gql`
  query MissionControlPaginatedApprovalChains(
    $limit: Int!
    $offset: Int!
    $orderField: MissionControlApprovalChainOrderField
    $orderDirection: OrderDirection
    $filters: MissionControlApprovalChainFilterInput
  ) {
    missionControlPaginatedApprovalChains(
      limit: $limit
      offset: $offset
      orderField: $orderField
      orderDirection: $orderDirection
      filters: $filters
    ) {
      approvalChains {
        id
        createdAt
        approvable {
          ... on StaffingRequest {
            id
            code
            startDate
            quantity
            state
            submissionsPaused
            canUpdate {
              value
            }
            role {
              id
              abbreviation
            }
            organizationUnit {
              id
              name
              clinicalUnit {
                id
                displayName
              }
              department {
                id
                name
                organizationBusiness {
                  id
                  name
                  city
                  stateCode
                }
              }
            }
            __typename
          }
          ... on ExtensionOffer {
            id
            __typename
          }
        }
      }
      totalCount
    }
  }
`;
